import { PRODUCT_ID } from "../constants/constants";
import { removeHash } from "./hash";

// export function defaultHeaders(headers: Headers, token?: string) {
//   const defaultHeader: Headers = headers;

//   if (token) {
//     defaultHeader.set("Authorization", `Bearer ${token}`);
//   }

//   defaultHeader.set("ngrok-skip-browser-warning", "true");

//   const productType = localStorage.getItem("product-type");

//   const productId =
//     (productType ? (removeHash(JSON.parse(productType)) as string) : 14) || 14;

//   defaultHeader.set("productId", productId?.toString());

//   return defaultHeader;
// }



export function defaultHeaders(headers: Headers, token?: string) {
  const defaultHeader: Headers = headers;

  if (token) {
    defaultHeader.set("Authorization", `Bearer ${token}`);
  }

  defaultHeader.set("ngrok-skip-browser-warning", "true");

  const productType = localStorage.getItem("product-type");
  const productId =
    (productType
      ? (removeHash(JSON.parse(productType)) as string)
      : PRODUCT_ID) || PRODUCT_ID;
  // const productId = 6;

  defaultHeader.set("productId", productId?.toString());

  return defaultHeader;
}
